import {
    cleanCommonParams,
    mapImageParams,
    mapSecondImageParams,
    mapStatesParams,
} from './common';

const mapCoBrandedVideoLogoParams = (
    isCreate,
    {
        image,
        second_image,
        states,
        ...params
    },
) => {
    return new Promise((resolve) => {
        resolve({
            co_branded_video_logo: {
                ...cleanCommonParams(params),
                ...mapImageParams(isCreate, image),
                ...mapSecondImageParams(isCreate, second_image),
                ...mapStatesParams(isCreate, states),
            },
        });
    });
};

export { mapCoBrandedVideoLogoParams };
